import React from 'react';
// import style from './Expositions.module.scss'

const Expositions = () => {
    return (
    <div>


    </div>
)};

export default Expositions;